module.exports = __webpack_public_path__ + "static/media/medications.118332f2.png";